export default "__VITE_ASSET__db003138__"